module.exports = __webpack_public_path__ + "static/media/bindOutlook1.164f17fb.png";